__turbopack_context__.v({
  "btn": "Features-module-scss-module__bd4jMa__btn",
  "featureBtnWrapper": "Features-module-scss-module__bd4jMa__featureBtnWrapper",
  "featureCard": "Features-module-scss-module__bd4jMa__featureCard",
  "featureRow": "Features-module-scss-module__bd4jMa__featureRow",
  "heading": "Features-module-scss-module__bd4jMa__heading",
  "imgBox": "Features-module-scss-module__bd4jMa__imgBox",
  "imgCol": "Features-module-scss-module__bd4jMa__imgCol",
  "main": "Features-module-scss-module__bd4jMa__main",
  "textBox": "Features-module-scss-module__bd4jMa__textBox",
  "textCol": "Features-module-scss-module__bd4jMa__textCol",
});
